export default {
  // 搜尋
  search: {
    title: '搜尋',
    resultsFor: '搜尋結果',
    noResults: '未找到相關內容',
    startSearching: '開始搜尋',
  },

  // 首頁
  home: {
    welcomeBack: '歡迎回來',
    discoverTravel: '探索旅行',
    discoverPlans: '發現精彩的旅行計畫',
    whereToGo: '想去哪裡玩?',
    viewMore: '查看更多',
    recommendedCards: '推薦卡片',
    latestPosts: '最新遊記',
    loginPrompt: '登入以建立和管理您的行程',
    loginButton: '登入/註冊',
  },

  // 卡片列表
  cardList: {
    title: '卡片瀏覽',
    searchPlaceholder: '搜尋卡片...',
    types: {
      poi: '景點',
      restaurant: '餐廳',
      lodging: '住宿',
      activity: '活動',
      shopping: '購物',
    },
    filters: {
      tags: '標籤',
      category: '分類',
      subcategory: '子分類',
      location: '地區',
      clear: '清除',
    },
    status: {
      loading: '載入中...',
      switchingPages: '正在切換頁面...',
      noMore: '沒有更多卡片了',
      emptyTitle: '未找到卡片',
      emptyText: '嘗試調整搜尋條件或過濾器',
    },
    modal: {
      title: '卡片詳情',
      close: '關閉',
      addToItinerary: '加入行程',
    }
  },

  // 模組頭部
  header: {
    title: '拼遊',
    subtitle: '智能行程推薦，AI收據辨識',
  },

  common: {
    close: '關閉',
  },

  // 旅行卡片
  travelCard: {
    status: {
      active: '進行中',
      planning: '計劃中',
      completed: '已完成',
      cancelled: '已取消',
    },
    actions: {
      viewDetails: '查看詳情',
      joinTravel: '加入拼遊',
      editTravel: '編輯拼遊',
      enterChat: '進入聊天',
    },
    info: {
      members: '成員',
      budget: '預算',
      duration: '時長',
      days: '天',
      perPerson: '/ 人',
      noLocation: '未設定地點',
      noBudget: '未設定預算',
      noMembers: '暫無成員',
      memberCount: '{{count}} 名成員',
      memberCount_plural: '{{count}} 名成員',
      actualCost: '實際費用',
      public: '公開',
      friendsOnly: '僅限好友',
      private: '私密',
    },
    dates: {
      to: '至',
      startDate: '出發日期',
      endDate: '返回日期',
    },
  },

  // 旅行列表
  travelList: {
    loading: {
      title: '正在載入拼遊列表...',
      subtitle: '請稍候',
    },
    empty: {
      title: '暫無拼遊',
      subtitle: '點擊右上角按鈕創建您的第一個拼遊',
    },
    messages: {
      error: '錯誤',
      fetchListFailed: '獲取項目列表失敗',
      unknownError: '未知錯誤',
      likeFailed: '點讚操作失敗',
    },
  },

  // 創建旅行
  createTravel: {
    // 頁面頭部
    header: {
      title: '創建拼遊',
      subtitle: '填寫項目資訊',
    },
    title: '創建旅行',
    // 基本資訊
    projectName: '拼遊名稱',
    projectNamePlaceholder: '為您的拼遊命名',
    dateRange: '旅行日期',
    startDate: '出發日期',
    endDate: '返回日期',
    // 目的地
    destination: '目的地',
    selectCountry: '選擇國家',
    selectCity: '選擇城市',
    customCity: '或輸入自訂城市',
    customCityPlaceholder: '輸入城市名稱（例如：巴黎、東京、紐約）',
    destinationLabel: '目的地：',
    // 旅行偏好
    travelPreferences: '您的旅行偏好',
    preferencesSubtitle: '選擇您感興趣的內容，幫助AI定製行程',
    multiSelect: '（可多選）',
    // 偏好選項
    preferences: {
      culture: '文化',
      food: '美食',
      scenery: '風景',
      history: '歷史',
      deepTour: '深度遊',
      checkin: '打卡',
    },
  // 項目描述
  projectDescription: '拼遊描述',
  projectDescriptionPlaceholder: '介紹此行程的特點與亮點...',
  editItinerary: '編輯行程',
    descriptionPlaceholder: '介紹此行程的特點與亮點...',
    aiGenerate: 'AI智能生成描述',
    aiGenerating: '正在生成...',
    // 支付模式
    paymentMode: '支付模式',
    prepayAverage: '預付均分',
    prepayAverageDesc: '提前收取固定金額，平均分配',
    prepayShare: '預付按份',
    prepayShareDesc: '提前收取固定金額，按份分配',
    actualAverage: '實際費用（均分）',
    actualAverageDesc: '實際費用後平均分配',
    actualShare: '實際費用（按份）',
    actualShareDesc: '實際費用後按份分配',
    // 結算貨幣
    settlementCurrency: '結算貨幣',
    selectCurrency: '選擇貨幣',
    // 貨幣名稱
    currencies: {
      CNY: '人民幣',
      USD: '美元',
      EUR: '歐元',
      JPY: '日元',
      GBP: '英鎊',
      AUD: '澳元',
      CAD: '加元',
      CHF: '瑞士法郎',
      HKD: '港幣',
      SGD: '新加坡元',
      KRW: '韓元',
      TWD: '新台幣',
      THB: '泰銖',
      MYR: '馬來西亞林吉特',
    },
    // 每人預算
    budgetPerPerson: '每人預算',
    budgetPlaceholder: '0',
    budgetUnit: '/ 人',
    budgetHint: '用於預算規劃和成員參考的每人預計費用',
    // 項目可見性
    projectVisibility: '項目可見性',
    visibilitySubtitle: '選擇誰可以查看和加入您的旅行項目',
    friendsVisible: '好友可見',
    friendsVisibleDesc: '好友可以查看並申請加入',
    privateProject: '私密項目',
    privateProjectDesc: '僅限邀請好友',
    // 背景圖片
    backgroundImage: '背景圖片',
    selectBackground: '選擇背景',
  backgroundPlaceholder: '點擊選擇背景圖片',
  // 相容鍵
  selectBackgroundPlaceholder: '點擊選擇背景圖片',
    backgroundImages: {
      beach: '海灘度假',
      churches: '教堂建築',
      airplane: '飛行之旅',
      cruise: '遊輪旅行',
      fuji: '富士山',
      germany: '德國風光',
      holland: '荷蘭風車',
      hongkong: '香港夜景',
      korea: '韓國風光',
      london: '倫敦印象',
      maldives: '馬爾地夫',
      mountain: '山地雪景',
      paris: '巴黎浪漫',
      sakura: '櫻花',
      sea: '湛藍海洋',
      shanghai: '上海風光',
      singapore: '新加坡印象',
      snow: '降雪',
      sunrise: '日出東方',
      sunsets: '日落西方',
      swiss: '瑞士風光',
      thailand: '泰國風情',
      vietnam: '越南印象',
      waterfalls: '飛瀑流泉',
    },
    // 按鈕
    createProject: '創建拼遊項目',
    next: '創建拼遊',
    // 提示消息
    alerts: {
      hint: '提示',
      success: '成功',
      error: '錯誤',
      enterProjectName: '請輸入拼遊名稱',
      selectDestination: '請選擇目的地',
      selectDestinationCity: '請選擇目的地城市',
      enterProjectDescription: '請輸入項目描述',
      invalidDateRange: '結束日期不能早於開始日期',
      generatedSuccess: 'AI描述生成成功！',
      generateFailed: 'AI生成失敗',
      aiGenerationFailed: 'AI生成失敗',
      errorDetails: '錯誤詳情',
      createSuccess: '拼遊項目創建成功！',
      createSuccessMessage: '您的拼遊項目已創建成功，快去邀請好友加入吧！',
      createFailed: '創建失敗',
      createFailedMessage: '請檢查網絡連接後重試',
      createFailedDetail: '如問題持續，請聯繫客服。',
      userNotLoggedIn: '用戶未登錄，請先登錄',
      unknownError: '未知錯誤',
      travelCreateFailed: '拼遊創建失敗',
      viewProject: '查看項目',
      // AI相關提示
      aiDisabledMessage: 'AI智能推薦功能已禁用\nAI行程生成已取消\n您可以在設定中重新啟用',
      goToSettings: '前往設定',
    },
    // AI提示相關
    aiPrompt: {
      role: '您是一位專業旅行規劃師。請為以下旅行項目生成詳細、吸引人且實用的行程介紹。',
      // 基本資訊部分
      basicInfo: '項目基本資訊',
      projectNameLabel: '項目名稱',
      destinationLabel: '目的地',
      travelTimeLabel: '旅行時間',
      participantsLabel: '參與者',
      preferencesLabel: '旅行偏好',
      budgetLabel: '每人預算',
      noPreferences: '無特定偏好',
      budgetTbd: '預算待定',
      paymentModeLabel: '支付模式',
      daysCount: '（共{days}天）',
      // 支付模式映射
      paymentModes: {
        prepay_average: '預付均分模式',
        prepay_share: '預付按份模式',
        actual_average: '實際費用均分模式',
        actual_share: '實際費用按份模式',
      },
      // 要求部分
      requirements: '生成要求',
      generateContent: '請生成包含以下內容的行程介紹：',
      contentItems: {
        highlights: '**項目亮點**：基於目的地特點和用戶偏好，突出此次旅行的獨特之處',
        itinerary: '**詳細行程**：按天計劃具體的景點、活動和體驗',
        food: '**美食推薦**：當地特色美食和餐廳推薦',
        accommodation: '**住宿建議**：適合團隊的住宿類型和區域',
        transportation: '**交通指南**：抵達目的地的交通方式及當地交通選擇',
        budget: '**預算參考**：各類費用的大致預算範圍',
        tips: '**實用貼士**：包括天氣、簽證、必需品及其他實用資訊',
        teamActivities: '**團隊活動**：適合{min}至{max}人團隊的特別活動',
      },
      // 風格要求部分
      styleRequirements: '風格要求',
      styleItems: {
        0: '生動有趣的語言，充滿吸引力',
        1: '內容詳細具體，注重實用性',
        2: '突出團隊合作和社交屬性',
        3: '反映團隊旅行的經濟效益和樂趣',
        4: '使用適當表情符號增加趣味',
        5: '總字數控制在400-500字',
      },
      generateStart: '請開始生成：',
    },
  },

  // 旅行詳情頁面
  travelDetail: {
    loading: {
      title: '正在載入拼遊詳情...',
      subtitle: '請稍候',
    },
    error: {
      title: '載入失敗',
      subtitle: '未找到拼遊項目',
      retryButton: '重新載入',
    },
    actions: {
      editItinerary: '編輯行程',
      approve: '核准',
      reject: '拒絕',
      settlement: '費用設定',
    },
    // 頁面內容
    content: {
      projectDescription: '拼遊描述',
      itineraryOverview: '行程總覽',
      todoList: '待辦事項',
      members: '旅行成員',
      add: '添加',
      expand: '展開',
      collapse: '收起',
      expandWithCount: '展開（{{count}} 項）',
      unknownUser: '未知用戶',
      creator: '創建者',
      member: '拼客',
      pending: '待審',
      pendingAdd: '待審 - 新增',
      pendingEdit: '待審 - 修改',
      completed: '已完成',
      inviteFriends: '邀請好友',
      recommendFriends: '推薦好友',
      noTodos: '暫無待辦事項',
      noTodosSubtext: '點擊右上角添加按鈕創建待辦事項',
    },
    // 彈窗
    modal: {
      paymentSettings: '支付設定',
      paymentMode: '支付模式',
      memberShareSettings: '成員份額設定',
      memberShareDescription: '為每個成員設定份額比例。例如：成人1.0，兒童0.5，情侶2.0',
      totalShares: '總份額',
      averageMode: '均分模式',
      shareMode: '按份模式',
      prepaidMode: '預付模式（旅行社模式，不可退款）',
      actualExpenseMode: '實際費用模式（按實際費用分配）',
      currentProjectUses: '當前項目使用',
    },
    // 消息
    messages: {
      success: '成功',
      error: '錯誤',
      loadFailed: '載入旅行詳情失敗',
      unknownError: '未知錯誤',
      userNotLoggedIn: '用戶未登錄',
      paymentSettingsSaved: '支付設定已保存',
      saveShareSettingsFailed: '保存份額設定失敗',
      addTodoFailed: '添加待辦事項失敗',
      batchAddTodosFailed: '批量添加待辦事項失敗',
      todosAdded: '已添加 {{count}} 個待辦事項',
      operationFailed: '操作失敗',
      likeFailed: '點讚操作失敗',
      insufficientPermission: '權限不足',
      needJoinFirst: '您需要先加入項目才能推薦好友',
      onlyCreatorCanInvite: '僅項目創建者可邀請好友加入私密項目',
      savePaymentModeFailed: '保存支付模式失敗',
    },
  },

  // 費用設定彈窗
  expenseSettingsModal: {
    // 頭部
    title: '費用分攤設定',
    cancel: '取消',
    save: '保存',
    // 權限通知
    permissionNotice: '僅旅行創建者可以修改費用設定',
    // 費用模式
    expenseModeSection: {
      title: '📊 分攤模式',
      subtitle: '選擇適合您旅行活動的費用管理方式',
      // 預付模式
      prepaidMode: {
        title: '預付模式',
        subtitle: '成員提前支付，統一費用管理',
        description: '適用於預算明確的旅行活動，如旅遊、聚會等。需設定總預算。',
        features: [
          '設定總預算金額',
          '成員按份額比例預付',
          '實時追蹤餘額',
          '退款或補交結算',
        ],
      },
      // 實際費用模式
      actualExpenseMode: {
        title: '實際費用模式',
        subtitle: '成員各自支付費用，之後按實際費用分攤',
        description: '適用於費用不確定的旅行活動，如項目合作等，無需預設預算。',
        features: [
          '上傳收據',
          '費用審批流程',
          '靈活的類別管理',
          '實際費用分攤',
        ],
      },
    },
    // 份額設定
    shareSection: {
      title: '⚖️ 份額比例',
      subtitle: '選擇具體的費用分攤方式',
      toggleTitle: '啟用按份分攤',
      // 不同模式描述
      descriptions: {
        prepaidWithShares: '預付後根據實際消費退款或補交，考慮個人差異',
        prepaidWithoutShares: '類似旅行團模式，創建者統一安排，平均分攤',
        actualExpenseWithShares: '按成員份額比例分攤實際費用',
        actualExpenseWithoutShares: '所有費用平均分攤，不考慮個人差異',
      },
      // 按份分攤示例
      shareExamples: {
        title: '💡 按份分攤說明',
        prepaidMode: '預付模式 + 按份分攤：\n• 成員按份額比例預付不同金額\n• 活動後根據實際消費重新計算\n• 反映個人差異，退款或補交\n• 適用場景：家庭旅行、朋友聚會',
        actualExpenseMode: '實際費用 + 按份分攤：\n• 成員各自支付，上傳收據\n• 按份額比例分攤總費用\n• 最終統一結算差額\n• 適用場景：項目合作、AA制聚會',
      },
      // 均等分攤示例
      averageExamples: {
        title: '📋 均等分攤說明',
        prepaidMode: '預付模式 + 均等分攤：\n• 每人預付相同金額\n• 創建者統一安排所有活動\n• 剩餘資金平均退款或繼續使用\n• 適用場景：公司團建、旅行團',
        actualExpenseMode: '實際費用 + 均等分攤：\n• 成員各自支付，上傳收據\n• 總費用在所有人中平均分攤\n• 最終統一結算差額\n• 適用場景：臨時活動、同事聚會',
      },
    },
    // 當前設定預覽
    currentSettings: {
      title: '📋 當前設定',
      expenseMode: '分攤模式',
      shareMode: '按份分攤',
      currency: '貨幣',
      prepaidMode: '預付模式',
      actualExpenseMode: '實際費用模式',
      enabled: '已啟用',
      averageMode: '均等分攤',
    },
  },

  // 費用統計
  statistics: {
    title: '旅行統計',
    loading: '正在計算統計數據...',
    // 概要統計
    summary: {
      totalSpent: '總支出',
      approvedAmount: '已審批金額',
      averageShare: '平均份額',
      averageSpent: '平均支出',
      budgetUsage: '預算使用率',
      expenseRecords: '費用記錄',
      approvedReceipts: '已審批收據',
      budgetProgress: '預算使用情況',
      pending: '待審',
      rejected: '已拒絕',
      receipts: '張收據',
      groupMode: '團購模式：預付，平均分攤，簡化管理',
    },
    // 類別統計
    categories: {
      title: '費用類別',
      transport: '交通',
      accommodation: '住宿',
      food: '餐飲',
      activities: '活動',
      shopping: '購物',
      documents: '證件',
      other: '其他',
    },
    // 成員統計
    members: {
      shareDetails: '成員份額詳情',
      spentStats: '成員支出統計',
      participation: '成員參與度',
      shareAmount: '份額金額',
      difference: '差額',
      shouldReceive: '應收金額',
      shouldPay: '應付金額',
      remainingBalance: '剩餘餘額',
      needPayment: '需支付',
      balanced: '已平衡',
      unknownUser: '未知用戶',
      totalSpent: '總支出',
      averagePerPerson: '每人平均',
      spent: '已支出',
      transactions: '筆交易',
    },
  },

  // 添加待辦事項彈窗
  addTodoModal: {
    // 頭部
    title: '添加待辦事項',
    // 自訂添加
    customAdd: {
      title: '自訂添加',
      titleLabel: '標題',
      titlePlaceholder: '輸入待辦事項標題',
      descriptionLabel: '描述',
      descriptionPlaceholder: '輸入詳細描述（可選）',
      priorityLabel: '優先級',
    },
    // 優先級
    priority: {
      high: '高',
      medium: '中',
      low: '低',
    },
  },

  // 邀請好友頁面
  inviteFriends: {
    header: {
      title: '邀請好友',
      subtitle: '邀請好友加入 "{{groupName}}"',
    },
    search: {
      placeholder: '搜索好友...',
    },
    sections: {
      available: '可邀請的好友',
      members: '已有成員',
      pending: '待處理的邀請',
    },
    status: {
      joined: '已加入項目',
      invitationSent: '邀請已發送，等待回覆',
    },
    actions: {
      sendInvitations: '發送邀請',
      sending: '發送中...',
      continueInviting: '繼續邀請',
      goBack: '返回',
    },
    loading: {
      text: '正在載入好友列表...',
    },
    empty: {
      noFriends: {
        title: '暫無好友',
        subtitle: '請先添加好友',
      },
      noResults: {
        title: '無搜索結果',
        subtitle: '嘗試其他關鍵詞',
      },
    },
    selection: {
      count: '已選擇 {{count}} 名好友',
      sendCount: '發送邀請 ({{count}})',
    },
    alerts: {
      selectFriends: '請選擇要邀請的好友',
      userInfoFailed: '獲取用戶資訊失敗',
      invitationSuccess: '邀請發送成功',
      invitationSuccessMessage: '已向 {{names}} 發送邀請',
      loadFriendsFailed: '載入好友列表失敗',
      sendInvitationsFailed: '發送邀請失敗',
      error: '錯誤',
      hint: '提示',
      unknownError: '未知錯誤',
      unknownUser: '未知用戶',
    },
  },

  // 目的地數據
  destinations: {
    countries: {
      // 亞洲
      CN: 'China',
      HK: 'Hong Kong',
      MO: 'Macau',
      TW: 'Taiwan',
      JP: 'Japan',
      KR: 'South Korea',
      TH: 'Thailand',
      SG: 'Singapore',
      MY: 'Malaysia',
      VN: 'Vietnam',
      ID: 'Indonesia',
      IN: 'India',
      AE: 'United Arab Emirates',
      // 歐洲
      GB: 'United Kingdom',
      FR: 'France',
      DE: 'Germany',
      IT: 'Italy',
      ES: 'Spain',
      NL: 'Netherlands',
      CH: 'Switzerland',
      // 北美
      US: 'United States',
      CA: 'Canada',
      // 大洋洲
      AU: 'Australia',
      NZ: 'New Zealand',
    },
    cities: {
      // 城市級目的地
      HongKong: '香港',
      Macau: '澳門',
      Singapore: '新加坡',
      // 中國城市
      Beijing: 'Beijing',
      Shanghai: 'Shanghai',
      Guangzhou: 'Guangzhou',
      Shenzhen: 'Shenzhen',
      Hangzhou: 'Hangzhou',
      Chengdu: 'Chengdu',
      // 台灣城市
      Taipei: 'Taipei',
      Kaohsiung: 'Kaohsiung',
      Taichung: 'Taichung',
      Tainan: 'Tainan',
      // 日本城市
      Tokyo: '東京',
      Osaka: '大阪',
      Kyoto: '京都',
      'JP-Kyoto': '京都',
      Nagoya: '名古屋',
      Fukuoka: '福岡',
      Sapporo: '札幌',
      // 韓國城市
      Seoul: 'Seoul',
      Busan: 'Busan',
      Daegu: 'Daegu',
      Incheon: 'Incheon',
      // 泰國城市
      Bangkok: 'Bangkok',
      ChiangMai: 'Chiang Mai',
      Phuket: 'Phuket',
      Pattaya: 'Pattaya',
      // 馬來西亞城市
      KualaLumpur: 'Kuala Lumpur',
      Penang: 'Penang',
      Malacca: 'Malacca',
      JohorBahru: 'Johor Bahru',
      // 越南城市
      HoChiMinhCity: 'Ho Chi Minh City',
      Hanoi: 'Hanoi',
      DaNang: 'Da Nang',
      NhaTrang: 'Nha Trang',
      // 印尼城市
      Jakarta: 'Jakarta',
      Bali: 'Bali',
      Yogyakarta: 'Yogyakarta',
      Surabaya: 'Surabaya',
      // 印度城市
      NewDelhi: 'New Delhi',
      Mumbai: 'Mumbai',
      Bangalore: 'Bangalore',
      Kolkata: 'Kolkata',
      // 阿聯酋城市
      Dubai: 'Dubai',
      AbuDhabi: 'Abu Dhabi',
      // 英國城市
      London: 'London',
      Edinburgh: 'Edinburgh',
      Manchester: 'Manchester',
      Liverpool: 'Liverpool',
      // 法國城市
      Paris: 'Paris',
      Lyon: 'Lyon',
      Marseille: 'Marseille',
      Nice: 'Nice',
      // 德國城市
      Berlin: 'Berlin',
      Munich: 'Munich',
      Hamburg: 'Hamburg',
      Frankfurt: 'Frankfurt',
      // 意大利城市
      Rome: 'Rome',
      Milan: 'Milan',
      Venice: 'Venice',
      Florence: 'Florence',
      // 西班牙城市
      Madrid: 'Madrid',
      Barcelona: 'Barcelona',
      Valencia: 'Valencia',
      Seville: 'Seville',
      // 荷蘭城市
      Amsterdam: 'Amsterdam',
      Rotterdam: 'Rotterdam',
      TheHague: 'The Hague',
      // 瑞士城市
      Zurich: 'Zurich',
      Geneva: 'Geneva',
      Basel: 'Basel',
      // 美國城市
      NewYork: 'New York',
      LosAngeles: 'Los Angeles',
      Chicago: 'Chicago',
      SanFrancisco: 'San Francisco',
      LasVegas: 'Las Vegas',
      Miami: 'Miami',
      // 加拿大城市
      Toronto: 'Toronto',
      Vancouver: 'Vancouver',
      Montreal: 'Montreal',
      Ottawa: 'Ottawa',
      // 澳洲城市
      Sydney: 'Sydney',
      Melbourne: 'Melbourne',
      Brisbane: 'Brisbane',
      Perth: 'Perth',
      // 紐西蘭城市
      Auckland: 'Auckland',
      Wellington: 'Wellington',
      Christchurch: 'Christchurch',
    },
  },

  // 旅行聊天
  travelChat: {
    header: {
      title: '{{groupName}} 聊天室',
      subtitle: '旅行群聊',
    },
    loading: {
      text: '正在載入聊天記錄...',
    },
    empty: {
      title: '暫無聊天記錄',
      subtitle: '開始與您的團隊成員聊天吧！',
    },
    input: {
      placeholder: '輸入消息...',
    },
    time: {
      today: '今天',
      yesterday: '昨天',
    },
    errors: {
      sendFailed: '發送失敗',
      networkError: '網絡錯誤，請重試',
    },
    user: {
      unknown: '未知用戶',
    },
  },

  // 費用管理
  expenseManagement: {
  fullAmount: '完整金額',
    ledgerTabs: {
      public: '群組帳本',
      private: '成員私帳',
    },
    // 統計
    statistics: {
      title: '費用統計',
      settings: '設定',
      consumed: '已消費',
      totalExpense: '總費用',
      approvedReceipts: '已審批收據',
      pendingReview: '待審',
      averagePerPerson: '人均',
      averagePerShare: '每份平均',
      categoryStatistics: '費用類別統計',
      shareMode: '按份分攤',
      averageMode: '均等分攤',
      perSharePayable: '每份應付',
      averageSplit: '均等分割',
    },
    // 收據
    receipts: {
      title: '收據',
      upload: '上傳',
      exportPDF: 'PDF',
      exporting: '正在導出...',
      approve: '審批',
      reject: '拒絕',
      confirmTitle: '確認操作',
      confirmApprove: '您確定要審批此收據嗎？',
      confirmReject: '您確定要拒絕此收據嗎？',
      cancel: '取消',
      confirm: '確認',
      approved: '收據已審批',
      rejected: '收據已拒絕',
      success: '操作成功',
      error: '操作失敗',
      approveFailed: '審批失敗',
      rejectFailed: '拒絕失敗',
      operationFailed: '操作失敗',
      imageUnavailable: '圖片不可用',
      imageLoadError: '圖片載入錯誤',
      cannotDisplay: '無法顯示圖片',
      emptyTitle: '暫無收據',
      emptySubtitle: '點擊上傳按鈕開始添加收據',
    },
    privateReceipts: {
      modeInfo: '這是成員個人記錄的私帳，只影響個人分帳。',
      loading: '正在載入私帳記錄…',
      loadFailed: '載入私帳記錄失敗',
      loadFailedHint: '請檢查網路連線後再試。',
      retry: '重試',
      emptyTitle: '還沒有私帳記錄',
      emptySubtitle: '成員可以上傳自己的私帳，或使用上方的「上傳」按鈕紀錄第一筆個人消費。',
      settlementTitle: '成員往來結算',
      settlementAmount: '{{payer}} 需要向 {{receiver}} 支付 {{amount}}',
      settlementYouOwe: '你需要向 {{receiver}} 支付 {{amount}}',
      settlementOwesYou: '{{payer}} 需要向你支付 {{amount}}',
      settlementEmpty: '大家都結清了，目前沒有成員往來。',
      noPersonalSettlements: '你沒有任何私人往來帳。',
      noPersonalReceipts: '尚未有與你相關的私帳紀錄。',
      noPersonalReceiptsSubtitle: '其他成員之間的私帳不會顯示在這裡。',
      youLabel: '你',
      vsSeparator: ' vs ',
      privateMode: {
        info: '私帳模式：在此上傳的收據為個人私帳，僅影響該成員的分攤。',
      },
    },
    // 狀態
    status: {
      pending: '待審',
      approved: '已審批',
      rejected: '已拒絕',
    },
    // 拒絕原因
    rejectionReason: {
      title: '拒絕原因',
    },
    // 拒絕輸入
    rejectInput: {
      title: '拒絕收據',
      label: '請輸入拒絕原因：',
      placeholder: '請詳細說明拒絕此收據的原因...',
      cancel: '取消',
      confirm: '確認拒絕',
    },
    // 成員餘額
    memberBalance: {
      title: '成員餘額',
      paid: '已支付',
      shouldPay: '應付金額',
      overpaid: '超付',
      owes: '欠款',
      share: '份額',
    },
    // 支付模式
    paymentMode: {
      prepaid: '預付模式',
      actualExpense: '實際費用',
      shareMode: '按份模式',
      equalMode: '均等模式',
    },
    // 類別統計
    categoryStats: {
      title: '類別統計',
      total: '總計',
    },
    // 類別
    categories: {
      transport: '交通',
      accommodation: '住宿',
      food: '餐飲',
      flight: '航班',
      taxi: '計程車',
      attractions: '景點',
      shopping: '購物',
      entertainment: '娛樂',
      insurance: '保險',
      visa: '簽證',
      communication: '通訊',
      general: '其他',
    },
    // 導出
    export: {
      error: '導出失敗',
      noData: '無數據可導出',
      success: '導出成功',
      successMessage: 'PDF報告已生成，可分享',
      failed: '導出失敗，請重試',
    },
    // PDF報告翻譯
    pdfReport: {
      title: '費用報告',
      subtitle: '財務詳情與統計分析',
      generatedBy: 'PDF生成者',
      brandName: 'Cube Meet',
      brandWebsite: 'https://cubemeet.app',
      generatedAt: '生成於',
      brandFooter: '由 Cube Meet 提供支持 - 智能財務管理平台',
      brandSlogan: '智能生活，從費用追蹤開始',
      // 部分標題
      sections: {
        overview: '財務概覽',
        memberBalances: '成員餘額詳情',
        expenseDetails: '費用詳情',
        receipts: '費用收據詳情',
        categoryStats: '費用類別統計',
        categoryBreakdown: '類別明細',
      },
      // 概覽項目
      overview: {
        totalExpense: '總費用',
        memberCount: '成員數',
        approvedReceipts: '已審批收據',
        pendingReceipts: '待審收據',
        memberUnit: '名成員',
        receiptUnit: '張收據',
      },
      // 表格標題
      tableHeaders: {
        member: '成員',
        spent: '已支出',
        shouldPay: '應付金額',
        balance: '餘額',
        share: '份額',
        title: '標題',
        amount: '金額',
        category: '類別',
        date: '日期',
        uploader: '上傳者',
        status: '狀態',
        percentage: '百分比',
        unknown: '未知',
      },
      // 狀態翻譯
      status: {
        approved: '已審批',
        rejected: '已拒絕',
        pending: '待審',
        unknown: '未知',
      },
      // 餘額狀態
      balanceStatus: {
        overpaid: '超付',
        owed: '欠款',
      },
    },
  },

  // 卡片詳情
  cardDetail: {
    tabs: {
      book: '預訂',
      details: '詳細資訊',
      nearby: '附近景點',
      description: '描述',
    },
    gallery: {
      allPhotos: '所有圖片',
      itineraryPhotos: '行程圖片',
      addPhoto: '添加圖片',
    },
    affiliate: {
      trip: '在 Trip 上搜尋景點優惠',
      klook: '在 Klook 上搜尋景點優惠',
      kkday: '在 KKday 上搜尋景點優惠',
      booking: '在 Booking.com 上搜尋優惠',
      agoda: '在 Agoda 上搜尋優惠',
    }
  },

  // 旅行帖子詳情
  travelPostDetail: {
    loading: '載入中...',
    emptyContent: '暫無內容',
    meta: {
      defaultTitle: '旅行筆記',
      siteName: '拼遊 Cubemeet',
    },
    breadcrumbs: {
      home: '首頁',
      city: '城市',
      guide: '指南',
    },
    messages: {
      cloneSuccess: '行程已複製，正在跳轉...',
      cloneFailed: '複製行程失敗，請稍後再試',
      postNotFound: '帖子不存在或已被刪除',
      loadFailed: '載入帖子失敗',
      followFailed: '關注失敗',
      followed: '已關注',
      addedToItinerary: '已成功加入行程',
      noMapData: '暫無地圖數據',
    },
    actions: {
      retry: '重試',
      back: '返回',
      backToTop: '回到頂部',
      cloneToItinerary: '複製為我的行程',
      viewMap: '地圖模式',
    },
    error: {
      notFound: '帖子不存在',
    },
    cloneModal: {
      title: '複製為我的行程',
      labelTitle: '行程標題',
      placeholderTitle: '輸入行程標題',
      labelStartDate: '出發日期',
      cancel: '取消',
      confirm: '確認複製',
      copyOf: 'Copy of',
    },
    postEngagement: {
      auth: {
        authenticated: '用戶已認證',
        unauthenticated: '用戶未認證',
        pleaseLogin: '請登錄後發表評論',
        checkFailed: '認證檢查失敗',
      },
      comment: {
        anonymous: '匿名用戶',
        empty: '評論內容為空',
        start: '開始發表評論',
        success: '評論發表成功',
        reload: '重新加載評論...',
        failed: '發表評論失敗',
        unknownError: '未知錯誤',
        placeholder: '說點什麼...',
        sending: '發送中...',
        send: '發送',
        total: '共 {{count}} 條評論',
        loading: '加載評論中...',
        loadMore: '加載更多評論',
        avatarError: '頭像加載失敗，使用默認頭像',
        replyingTo: '回覆 @ {{name}}',
      },
      time: {
        justNow: '剛剛',
        minsAgo: '{{count}}分鐘前',
        hoursAgo: '{{count}}小時前',
        daysAgo: '{{count}}天前',
      },
      badge: {
        author: '作者',
        admin: '管理員',
        agency: '認證',
      },
      richContent: {
        imageLoadFailed: '圖片加載失敗:',
        imageAlt: '圖片',
        empty: '暫無內容',
      },
    },
  },

  snapshot: {
    noContent: '暫無內容',
    imageLoadFailed: '圖片載入失敗',
    day: '第 {{number}} 天',
    openCardDetails: '打開卡片詳情',
    openCardInNewWindow: '在新視窗打開卡片',
    prevImage: '上一張',
    nextImage: '下一張',
    openExternalLink: '打開連結',
    openExternalLinkTitle: '在新視窗打開連結',
    addToItinerary: '加入行程',
    addToItineraryTitle: '將此項目加入我的行程',
  },
};